<!-- <app-header [transparent]="false" [title]="i18n.langString('edge_device_health')"></app-header> -->

@if (loading()) {
  <div class="spinner-container" [class.desktop]="isDesktop()">
    <app-spinner [black]="true"></app-spinner>
  </div>
}

<div class="content" [class.desktop]="isDesktop()">
  @if (isDesktop()) {
    <div class="desktop-sidebar white-sidebar">
      <app-sidebar
        [showList]="true"
        [asset]="asset()"
        [loading]="loading()"
        [sensorHealthPage]="true"
      >
      </app-sidebar>
    </div>
  }

  @if (!!asset() && !loading()) {
    <div [class.desktop-main]="isDesktop()">
      @if (!isDesktop() && !!asset()?.breadcrumbs) {
        <app-breadcrumbs
          [array]="Breadcrumbs()"
          [isAsset]="true"
          class="detail-bold"
        >
        </app-breadcrumbs>
      }

      @if (isDesktop()) {
        <div
          class="asset-back-btn"
          tabindex="0"
          role="button"
          (click)="goBack()"
          (keydown.enter)="goBack()"
          (keydown.space)="goBack()"
        >
          <i nz-icon nzType="icons:arrow-left" class="svg-icon fillwhite"></i>
          <span>{{
            i18n.langString("back_to") + i18n.parse(asset()?.objectName)
          }}</span>
        </div>
      }

      <div>
        @for (telemetry of HealthTelemetry(); track $index) {
          <div class="telemetry-item">
            <div
              class="sensor-header flat-sensor"
              [class.desktop]="isDesktop()"
            >
              <i
                nz-icon
                [nzType]="'icons:' + telemetry.svg"
                class="sensor-icon svg-icon"
              ></i>
              <div class="sensor-header-inner-div">
                <h2>
                  {{ i18n.parse(telemetry.title) }}
                  {{ i18n.langString("of_the_edge_device") }}
                </h2>
              </div>
            </div>
            <app-sensor-value
              [telemetry]="telemetry"
              [asHealth]="true"
              (click)="
                toSensorValue(
                  telemetry?.sensor?.sensorID,
                  telemetry?.measurementTypeID
                )
              "
            >
            </app-sensor-value>
          </div>
        }
      </div>

      @if (DisplayErrorCard()) {
        <div class="error-card">
          <span class="error-card-title">{{
            i18n.langString("problem_detected_title")
          }}</span>
          <div class="error-card-content">
            <i
              nz-icon
              nzType="icons:status-exclamation-triangle"
              class="svg-icon fillwhite"
            ></i>
            <span class="error-card-text">
              {{ i18n.langString("problem_detected_text") }}
              {{ i18n.langString("contact_service_text") }}
            </span>
          </div>
        </div>
      }
    </div>
  }
</div>
